// /client/src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes/Routes';
// import { usePageTracking } from './hooks/useAnalytics';
import 'bulma/css/bulma.min.css';

// Component to handle page tracking (must be inside Router)
// const PageTracker = () => {
//   usePageTracking();
//   return null;
// };

const App = () => {
  return (
    <>
      <main id="main" className="hide-this"></main>
      <div className="App">
        <Router>
          <AuthProvider>
            {/* <PageTracker /> */}
            <AppRoutes />
          </AuthProvider>  
        </Router>
      </div>
    </>
  );
};

export default App;